import { storageService } from "lib/utils/localStorage";
import { GDL_COOKIES_DOMAIN } from "../utils/cookies";

const UTM_SOURCE_KEY = "utm_source";
const GENERIC_UTM_SOURCE_REGEX = /^utm$/i;
// Constants
const STORAGE_KEY = "gdl_utm";

const KEY_MAPPINGS = {
  name: "name",
  campaign: "name",
  source: "source",
  medium: "medium",
  term: "term",
  content: "content",
  context: "context",
};

function getCaseInsensitiveRouteData() {
  const searchParams = new URLSearchParams(window.location.search);
  const out = {};

  for (const [key, value] of searchParams.entries()) {
    out[key.toLowerCase()] = value;
  }

  return out;
}

function normalizeUTMData(data) {
  if (!data || typeof data !== "object") return {};

  const normalizedEntries = Object.entries(data)
    .filter(([key]) => key.indexOf("utm") === 0)
    .map(([key, value]) => [GENERIC_UTM_SOURCE_REGEX.test(key) ? UTM_SOURCE_KEY : key, value]);

  return normalizedEntries.reduce(
    (accumulator, [key, value]) => ({
      ...accumulator,
      [key]: value,
    }),
    {}
  );
}

function domainNameFromHost(hostName) {
  if (!hostName) return;

  return hostName.split(".").slice(-2)[0];
}

function isInternalDomain(url) {
  if (url == null) return false;

  const domainName = domainNameFromHost(GDL_COOKIES_DOMAIN);
  const parsedDomainName = domainNameFromHost(new URL(url).hostname);

  return domainName === parsedDomainName;
}

function normalizeReferrer(referrer = document.referrer) {
  if (!referrer) return undefined;
  if (isInternalDomain(referrer)) return undefined;

  return referrer;
}

// Helpers
export function getUtmData() {
  return storageService.get(STORAGE_KEY)?.data;
}

export function getReferrer() {
  return storageService.get(STORAGE_KEY)?.referrer;
}

function stripUtmPrefixes(data) {
  return Object.keys(data).reduce((acc, key) => {
    let sanitizedKey = key.replace("utm_", "");

    sanitizedKey = KEY_MAPPINGS[sanitizedKey];
    if (!sanitizedKey) return acc;

    return {
      ...acc,
      [sanitizedKey]: data[key],
    };
  }, {});
}

export function evaluateUtmData() {
  const routeData = getCaseInsensitiveRouteData();
  const referrer = normalizeReferrer();

  let data = normalizeUTMData(routeData);

  data = stripUtmPrefixes(data);

  // Only update UTM and referrer if either are present on current page
  if (Object.keys(data).length === 0 && !referrer) return;

  storageService.set(STORAGE_KEY, {
    data,
    referrer,
  });
}
